export default "__VITE_ASSET__BidbOQOR__"